// extracted by mini-css-extract-plugin
module.exports = {"bar":"TopAnnounce-module--bar--2FylD","text":"TopAnnounce-module--text--1D4lm"};